import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-xl mx-auto px-6 py-24 text-center">
      <XCircle className="w-14 h-14 text-[#4A148C] mx-auto" />
      <h1 className="font-display text-4xl text-[#2C1810] mt-6">Payment cancelled</h1>
      <p className="font-body text-[#5B3D2A] mt-3">
        No worries — your cart is still saved. You can complete your order anytime.
      </p>
      <div className="flex gap-3 justify-center mt-8">
        <Link to="/cart" className="rounded-full bg-[#E65C00] text-white px-6 py-3 hover:bg-[#C44A00]">Back to cart</Link>
        <Link to="/shop" className="rounded-full border border-[#4A148C] text-[#4A148C] px-6 py-3">Keep shopping</Link>
      </div>
    </div>
  );
}
